module.exports = __webpack_public_path__ + "static/media/HairBack_1.c5754aca.jpg";